import { CONVERSATION_MESSAGE_ITEM_PINNED_REMOVE } from '@/config/api/api-routes';
import { ERROR_MESSAGE } from '@/config/messages';
import { http } from '@/shared/api/http';
import type { ApiErrorResponse } from '@/shared/types/result-api';
import { confirmMes } from '@/shared/utilities';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

export const useMessageDeletePin = (convId: string) => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ messageId, bucketId }: { messageId: string; bucketId: string }) => {
      await http.delete(
        CONVERSATION_MESSAGE_ITEM_PINNED_REMOVE.replace(':conversationId', convId).replace(':messageId', messageId),
        {
          data: {
            bucketId
          }
        }
      );
    },
    onError: (error: any) => {
      let errorMessage = ERROR_MESSAGE;

      // Handle different error response formats
      if (error?.response?.data) {
        const errorData = error.response.data as ApiErrorResponse;
        errorMessage = errorData.detail || errorData.message || errorData.title || ERROR_MESSAGE;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    }
  });

  return {
    xoa: async (messageId: string, bucketId: string) => {
      const res = await confirmMes({
        title: 'Xóa ghim',
        description: `Bạn có chắc chắn muốn bỏ ghim tin nhắn này?`,
        confirmText: 'Xóa'
      });

      if (res) {
        await mutateAsync({ messageId, bucketId });
      }
    },
    isDeleting: isPending
  };
};
